import { useMediaQuery } from 'react-responsive';

type HiddenView = `Desktop` | `Table` | `Mobile` | `Default`;

const getViewSize = (view: HiddenView) => {
  switch (view) {
    case `Desktop`:
      return 1280;
    case `Table`:
      return 1024;
    case `Mobile`:
      return 768;
    default:
      return 640;
  }
};
export type HiddenProps = {
  in?: `Desktop` | `Table` | `Mobile` | `Default`;
  not?: boolean;
  children: any;
};

/**
 * @component Hidden
 */
function Hidden({ in: inView = `Default`, not, children }: HiddenProps): any {
  const isInQuery = useMediaQuery({ minWidth: getViewSize(inView) });

  return (not ? !isInQuery : isInQuery) ? children : null;
}

export default Hidden;
